<nb-card>
    <nb-card-header>{{title}}</nb-card-header>
    <nb-card-body>
        {{message}}
    </nb-card-body>
    <nb-card-footer>
        <button nbButton class="left" status="danger" (click)="cancel()">Cancel</button>
        <button nbButton class="right" status="success" (click)="submit()">Submit</button>
    </nb-card-footer>
</nb-card>